import { makeStyles, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import { Image } from 'expo-image'
import React from 'react'
import { View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { RoundedButton } from 'shared/components/rounded-button'

type Props = {
  onSignIn: (locale: string) => void
}

export function WelcomeView(props: Props) {
  const styles = useStyles()

  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.root}>
      <View style={styles.container}>
        <Image
          source={require('assets/routes/onboarding/logo_small.png')}
          style={styles.image}
          contentFit="contain"
        />
        <View style={styles.greetings}>
          <Text style={styles.text}>{t('hello', { locale: 'en' })}</Text>
          <Text style={styles.text}>{t('hello', { locale: 'es' })}</Text>
        </View>
        <View>
          <RoundedButton
            title={t('signIn', { locale: 'en' })}
            onPress={() => props.onSignIn('en')}
            buttonStyle={[styles.button, styles.enButton]}
            titleStyle={styles.enButtonText}
          />
          <RoundedButton
            title={t('signIn', { locale: 'es' })}
            onPress={() => props.onSignIn('es')}
            buttonStyle={[styles.button, styles.esButton]}
            titleStyle={styles.esButtonText}
          />
        </View>
      </View>
    </SafeAreaView>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
  },
  container: {
    flex: 1,
    paddingTop: 200,
    alignItems: 'center',
  },
  image: {
    width: 200,
    height: 200,
  },
  greetings: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: 200,
    marginBottom: 20,
  },
  button: {
    width: 175,
    marginBottom: 15,
    borderColor: theme.colors.grey8,
    borderWidth: 1,
  },
  enButton: {
    backgroundColor: theme.colors.grey8,
  },
  esButton: {
    width: 175,
    marginBottom: 15,
    backgroundColor: 'white',
    borderColor: theme.colors.grey8,
    borderWidth: 1,
  },
  esButtonText: { color: theme.colors.grey8 },
  enButtonText: { color: 'white' },
  text: {
    fontSize: 32,
    marginBottom: 16,
    color: theme.colors.grey8,
  },
}))
